import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import Footer from 'components/login/Footer';
import { chgPw } from 'services/api-service/center';

const Password = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setFocus,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
  });
  const newPassword = watch('newPassword');
  const passedId = location.state?.userId;

  const onSubmit = async (data: any) => {
    fetchChange(data);
  };

  const fetchChange = async (data: any) => {
    try {
      const response: any = await chgPw(passedId, data.oldPassword, data.newPassword);
      if (response.result === 'success') {
        toast.success('비밀번호가 변경되었습니다.');
        navigate('/');
      } else {
        return toast(response.error_msg, { type: 'error' });
      }
    } catch (error) {
      console.error('fetchChange ', error);
    }
  };

  useEffect(() => {
    setFocus('oldPassword');
  }, [setFocus]);

  // useEffect(() => {
  //   if (!passedId) {
  //     toast.error('잘못된 접근입니다. 다시 로그인해 주세요.');
  //     navigate('/', { replace: true });
  //     return;
  //   }

  //   setFocus('oldPassword');
  // }, [passedId, navigate, setFocus]);

  // if (!passedId) {
  //   return null;
  // }

  return (
    <PasswordTemplateWrap>
      <CenterWrap>
        <Logo>
          <img src={process.env.PUBLIC_URL + '/images/login_logo.svg'} alt="logo" />
        </Logo>

        <FormTitle>비밀번호 변경</FormTitle>
        <GuideText>• 영문, 숫자, 특수문자 3가지 조합으로 최소 9자 이상 20자 이하로 등록 가능합니다.</GuideText>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* 기존 비밀번호 */}
          <HorizontalWrap>
            <ColorWrap />
            <ImageWrap>
              <img src={process.env.PUBLIC_URL + '/images/icon_pw.svg'} alt="pw" />
            </ImageWrap>
            <InputBox
              type="password"
              placeholder="기존 비밀번호"
              {...register('oldPassword', {
                required: '기존 비밀번호를 입력해주세요.',
                minLength: 9,
                maxLength: 20,
              })}
            />
          </HorizontalWrap>

          {/* 신규 비밀번호 */}
          <HorizontalWrap>
            <ColorWrap />
            <ImageWrap>
              <img src={process.env.PUBLIC_URL + '/images/icon_pw_new.svg'} alt="new pw" />
            </ImageWrap>
            <InputBox
              type="password"
              placeholder="신규 비밀번호"
              {...register('newPassword', {
                required: true,
                pattern: /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{9,20}$/,
              })}
            />
          </HorizontalWrap>

          {/* 신규 비밀번호 확인 */}
          <HorizontalWrap>
            <ColorWrap />
            <ImageWrap>
              <img src={process.env.PUBLIC_URL + '/images/icon_pw_check.svg'} alt="check pw" />
            </ImageWrap>
            <InputBox
              type="password"
              placeholder="신규 비밀번호 확인"
              {...register('confirmPassword', {
                required: true,
                validate: (value) => value === newPassword || '비밀번호가 일치하지 않습니다.',
              })}
            />
          </HorizontalWrap>

          <ErrorMessage>
            {(() => {
              if (errors.oldPassword?.type === 'required') {
                return <p>기존 비밀번호를 입력해주세요.</p>;
              }
              if (errors.oldPassword?.type === 'minLength' || errors.oldPassword?.type === 'maxLength') {
                return <p>기존 비밀번호를 9자 이상 20자 이하로 입력해주세요.</p>;
              }
              if (errors.newPassword?.type === 'required') {
                return <p>새 비밀번호를 입력해주세요.</p>;
              }
              if (errors.newPassword?.type === 'minLength' || errors.newPassword?.type === 'maxLength') {
                return <p>최소 9자 이상 20자 이하로 입력해주세요.</p>;
              }
              if (errors.newPassword?.type === 'pattern') {
                return <p>비밀번호 조합 규칙이 맞지 않습니다.</p>;
              }
              if (errors.confirmPassword?.type === 'required') {
                return <p>비밀번호 확인을 입력해주세요.</p>;
              }
              if (errors.confirmPassword?.type === 'validate') {
                return <p>{String(errors.confirmPassword.message)}</p>;
              }
              return null;
            })()}
          </ErrorMessage>

          <SubmitButton type="submit" value={'확인'} />
        </form>
      </CenterWrap>
      <Footer />
    </PasswordTemplateWrap>
  );
};

const PasswordTemplateWrap = styled.div`
  width: 100%;
  height: 100vh;
  background: #002343;
  position: relative;
`;
const CenterWrap = styled.div`
  position: absolute;
  width: 28.1875rem;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
`;
const Logo = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;
const FormTitle = styled.h2`
  color: #fff;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
`;
const GuideText = styled.p`
  color: #dddddd;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.4;
`;
const HorizontalWrap = styled.div`
  display: flex;
  width: 100%;
  height: 3rem;
  margin-bottom: 18px;
  background: #f5f5f5;
`;
const ColorWrap = styled.div`
  width: 0.375rem;
  height: 3rem;
  background: #e63528;
`;
const ImageWrap = styled.div`
  width: 3rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.5rem;
`;
const InputBox = styled.input`
  flex: 1;
  height: 3rem;
  border: none;
  background: transparent;
  padding: 0 1rem;
  font-size: 14px;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #ccc;
  }
`;
const ErrorMessage = styled.div`
  height: 1.5rem;
  color: #e63528;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  text-align: left;
`;
const SubmitButton = styled.input`
  width: 100%;
  height: 3rem;
  border-radius: 1.75rem;
  background: #e63528;
  border: none;
  cursor: pointer;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 700;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.9;
  }
`;

export default Password;
